import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { InspectionHttpEditRequestModel } from '../httpQueue/inspection/types';
import { InspectionOutDto } from 'shared/dtos/out/inspection';

export class InspectionEditor {
  constructor(
    private addRequest: (
      request: InspectionHttpEditRequestModel
    ) => Promise<any>
  ) {}

  async execute(
    inspectionId: string,
    inspectionOutDto: Partial<InspectionOutDto>,
    uniqueId: string,
    projectId: string
  ): Promise<void> {
    debugLog('InspectionEditor', inspectionId, inspectionOutDto);
    const request: InspectionHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionId,
        inspectionOutDto,
        uniqueId,
        projectId,
      },
      entityType: HttpRequestModelType.inspection,
      status: HttpRequestStatus.NEW,
      url: `/project/${projectId}/inspection/${inspectionId}`,
    };

    await this.addRequest(request);
  }
}

export const inspectionEditor = new InspectionEditor(addRequest);
